import React from "react";
import UpdateCard from "./updateCard";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import { slugToCountryPathname } from "../../utils/strings";

const LatestUpdates = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  return (
    <div id="latestUpdates">
      <div className="title">{content.title}</div>
      <div className="updatesCards">
        <div className="updatesTitle">{content.updatesTitle}</div>
        {content.updatesCards.map((card, i) =>
          isMobile ? (
            <Link key={i} to={slugToCountryPathname(card.link.path)}>
              <UpdateCard content={card} />
            </Link>
          ) : (
            <UpdateCard key={i} content={card} />
          )
        )}
      </div>
    </div>
  );
};

export default LatestUpdates;
